import { Card, CardContent } from "@/components/ui/card";
import { Layers, FileText, Users, Receipt } from "lucide-react";

function formatNumber(num) {
  return new Intl.NumberFormat("en-IN").format(num || 0);
}

/**
 * Stats tiles row for the Dashboard. Pure presentation.
 */
export default function DashboardStats({ summary }) {
  const stats = [
    { title: "COA Groups", value: summary?.groups || 0, icon: Layers, color: "text-blue-600", bg: "bg-blue-50" },
    { title: "Ledgers", value: summary?.ledgers || 0, icon: FileText, color: "text-emerald-600", bg: "bg-emerald-50" },
    { title: "Trial Balance Accounts", value: summary?.accounts || 0, icon: Users, color: "text-amber-600", bg: "bg-amber-50" },
    { title: "Vouchers", value: summary?.vouchers || 0, icon: Receipt, color: "text-purple-600", bg: "bg-purple-50" },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {stats.map((stat) => {
        const Icon = stat.icon;
        return (
          <Card
            key={stat.title}
            className="border border-slate-200 shadow-none card-hover"
            data-testid={`stat-card-${stat.title.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs font-medium text-slate-500 uppercase tracking-wider">
                    {stat.title}
                  </p>
                  <p className="text-2xl font-bold text-slate-900 mt-1 font-mono tabular-nums">
                    {formatNumber(stat.value)}
                  </p>
                </div>
                <div className={`p-3 rounded-sm ${stat.bg}`}>
                  <Icon className={`w-5 h-5 ${stat.color}`} />
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
